// export interface Caption {
//   start: string;
//   end: string;
//   text: string;
// }
// export const parseVTT = (vttContent: string): Caption[] => {
//   // Remove 'WEBVTT' header and split into lines
//   const lines: string[] = vttContent
//     .split("\n")
//     .slice(1) // Remove the 'WEBVTT' header
//     .filter((line) => line.trim() !== ""); // Exclude empty lines

//   const captions: Caption[] = [];
//   let currentCaption: Caption | null = null;

//   for (let i = 0; i < lines.length; i++) {
//     const line = lines[i].trim();

//     // Check if the line contains a timestamp
//     if (line.includes("-->")) {
//       const [start, end] = line.split("-->").map((time) => time.trim());
//       currentCaption = { start, end, text: "" }; // Start a new caption
//       continue;
//     }

//     // If we're in the middle of a caption, collect text
//     if (currentCaption && !line.match(/^[a-z0-9-]+-\d+$/)) {
//       currentCaption.text += line + " ";
//     }

//     // End of a caption block or reaching a new timestamp
//     if (
//       currentCaption &&
//       (i === lines.length - 1 || lines[i + 1].includes("-->"))
//     ) {
//       currentCaption.text = currentCaption.text.trim();
//       captions.push(currentCaption);
//       currentCaption = null;
//     }
//   }

//   return captions;
// };

export interface TranscriptEntry {
  speaker: string;
  speech: string;
}

export function convertVttToTranscript(vttContent: string): TranscriptEntry[] {
  // Split content by lines
  const lines = vttContent.split("\n");

  // Initialize variables
  const transcript: TranscriptEntry[] = [];
  let currentSpeaker = "";
  let currentSpeech = "";
  let collectingText = false;
  let isGenericVtt = true; // Assume generic VTT format initially
  let processingSubtitle = false; // Flag to track if we're processing text after a timestamp

  // Process each line
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();

    // Check if line is a timestamp
    const isTimestamp =
      line.match(/^\d{2}:\d{2}.\d{3} --> \d{2}:\d{2}.\d{3}/) !== null;

    // Skip empty lines, WEBVTT header, cue identifiers
    if (line === "" || line === "WEBVTT" || line.match(/^[a-zA-Z0-9-]+-\d+$/)) {
      continue;
    }

    // If we encounter a timestamp, start processing the subtitle text that follows
    if (isTimestamp) {
      processingSubtitle = true;
      continue; // Skip the timestamp line itself
    }

    // Skip if not processing subtitle text
    if (!processingSubtitle) {
      continue;
    }

    // Check if the line contains a speaker marker (Name:)
    const speakerMatch = line.match(/^(.+?):\s(.+)$/);

    if (speakerMatch) {
      isGenericVtt = false; // If we find a speaker format, it's not a generic VTT

      // If we were collecting text for a previous speaker, save it
      if (collectingText && currentSpeaker !== undefined) {
        transcript.push({
          speaker: currentSpeaker,
          speech: currentSpeech.trim(),
        });
      }

      // Start new speaker and speech
      currentSpeaker = speakerMatch[1].trim();
      currentSpeech = speakerMatch[2].trim();
      collectingText = true;
    } else {
      // If it's the first content line in generic VTT format
      if (isGenericVtt && !collectingText) {
        currentSpeaker = ""; // Empty speaker for generic VTT
        currentSpeech = line;
        collectingText = true;
      } else if (collectingText) {
        // For generic VTT: check if this is a new statement or continuation
        if (isGenericVtt && currentSpeech.match(/[.!?]$/)) {
          // Complete statement - save current and start new
          transcript.push({
            speaker: currentSpeaker,
            speech: currentSpeech.trim(),
          });
          currentSpeech = line;
        } else {
          // Continue the current speech/statement
          currentSpeech += " " + line;
        }
      }
    }
  }

  // Add the last entry if exists
  if (collectingText && currentSpeech) {
    transcript.push({
      speaker: currentSpeaker,
      speech: currentSpeech.trim(),
    });
  }

  // For generic VTT, no further consolidation needed as we already break at statement endings
  if (!isGenericVtt) {
    // For speaker-based VTT, consolidate consecutive entries from the same speaker
    const consolidatedTranscript: TranscriptEntry[] = [];

    for (const entry of transcript) {
      const lastEntry =
        consolidatedTranscript[consolidatedTranscript.length - 1];

      if (lastEntry && lastEntry.speaker === entry.speaker) {
        // If the same speaker, combine the speech
        lastEntry.speech += " " + entry.speech;
      } else {
        // New speaker, add new entry
        consolidatedTranscript.push({ ...entry });
      }
    }

    return consolidatedTranscript;
  }

  console.log(transcript);
  return transcript;
}
